import { SearchBarModule } from './../../search-bar/search-bar.module';
import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { FormsModule } from "@angular/forms";

import { IonicModule } from "@ionic/angular";

import { SpaceReservationsComponent } from "./space-reservations.component";
import { TranslateModule } from "@ngx-translate/core";
import { PaginationClientSideModule } from "src/app/app/_component/pagination-client-side/pagination-client-side.module";
import { ParkingBookingViewModule } from "../space-booking-view/space-booking-view.module";
import { LoadingStiModule } from "src/app/_component/loading-sti/loading-sti.module";
import { ParkingFilterModule } from "../space-filter/space-filter.module";
import { ParkingBookingViewChangeUserModule } from "../space-booking-view/space-booking-view-change-user/space-booking-view-change-user.module";
import { SharedDirectivesModule } from "src/app/_directives/shared-directives.module";
import { UserAssignmentViewDetailsComponentModule } from "../user-assignment-view/user-assignment-view-details/user-assignment-view-details.module";
import { ListHeaderComponentModule } from "../../_structural/list-header/list-header.module";

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    IonicModule,
    TranslateModule,
    PaginationClientSideModule,
    ParkingBookingViewModule,
    LoadingStiModule,
    ParkingFilterModule,
    SharedDirectivesModule,
    ParkingBookingViewChangeUserModule,
    UserAssignmentViewDetailsComponentModule,
    ListHeaderComponentModule,
    SearchBarModule
  ],
  declarations: [SpaceReservationsComponent],
  exports: [SpaceReservationsComponent],
})
export class SpaceReservationsComponentModule {}
